@if (egiAppContext.activeApp$ | async; as activeApp) {
  <div class="page-menu-header">
    <span class="page-menu-header__title">{{ activeApp.name }}</span>
  </div>
}
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="page-menu-tree">
  <mat-tree-node
    style="width: 100%"
    *matTreeNodeDef="let node"
    [hidden]="
      node.navigationItem.type === 5 ||
      !node.navigationItem.isBaseAccessAllowed ||
      node.navigationItem.isMenuItemWithNoDirectlyNavigableDescendants
    "
    >
    <egi-navigation-item
      [style.padding-left]="0.75 + 0.5 * node.level + 'em'"
      style="width: 100%"
      [navigationItem]="node.navigationItem"
      [href]="linkHref(node.navigationItem)"
      class="clickable page-menu-item"
      [class.page-menu-item--active]="node.navigationItem.is(egiAppContext.activeNavigationItem$ | async)"
      [class.page-menu-item--active-parent]="isAncestorOfActive(node.navigationItem)"
      [class.page-menu-item--sub]="node.level > 0"
      (click)="treeControl.toggle(node); onNavigationItemClick(node.navigationItem)"
      [expanded]="treeControl.isExpanded(node)"
      >
      @if (canOpenInNewTab(node.navigationItem)) {
        <button
          type="button"
          class="page-menu-item__new-tab"
          [title]="'platform.menu.openInNewTab' | transloco"
          [attr.aria-label]="'platform.menu.openInNewTab' | transloco"
          (click)="openInNewTab(node.navigationItem, $event)"
          >
          <i eIcon icon="arrow-up-right-from-square"></i>
        </button>
      }
    </egi-navigation-item>
  </mat-tree-node>
</mat-tree>
<div class="page-menu-footer">
  <span class="micro">v{{ appService.version }}</span>
</div>

